/**
 * Page status constants
 */
export const PAGE_STATUS = {
  DRAFT: false,
  PUBLISHED: true
};

/**
 * PageData class for handling page objects
 * Mirrors the backend PageResponse model
 */
export class PageData {
  constructor(data) {
    this.page_id = data.page_id;
    this.name = data.name || '';
    this.slug = data.slug || '';
    this.content = data.content || '';
    this.description = data.description || null;
    this.is_published = data.is_published ?? false;
    this.created_by = data.created_by || null;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }

  /**
   * Check if page is published
   */
  get isPublished() {
    return this.is_published === true;
  }

  /**
   * Check if page is a draft
   */
  get isDraft() {
    return !this.is_published;
  }

  /**
   * Create PageData from API response
   */
  static fromApiResponse(data) {
    return new PageData(data);
  }

  /**
   * Create array of PageData from API response list
   */
  static fromApiResponseList(dataList = []) {
    return dataList.map(PageData.fromApiResponse);
  }

  /**
   * Convert to format suitable for API create requests
   */
  toCreateFormat() {
    return {
      name: this.name,
      slug: this.slug,
      content: this.content,
      description: this.description,
      is_published: this.is_published
    };
  }

  /**
   * Convert to format for update (only changed fields)
   */
  toUpdateFormat(changes) {
    const format = {};
    if (changes.name !== undefined) format.name = changes.name;
    if (changes.slug !== undefined) format.slug = changes.slug;
    if (changes.content !== undefined) format.content = changes.content;
    if (changes.description !== undefined) format.description = changes.description;
    if (changes.is_published !== undefined) format.is_published = changes.is_published;
    return format;
  }
}

/**
 * PageListItem for list views (without full content)
 */
export class PageListItem {
  constructor(data) {
    this.page_id = data.page_id;
    this.name = data.name || '';
    this.slug = data.slug || '';
    this.description = data.description || null;
    this.is_published = data.is_published ?? false;
    this.updated_at = data.updated_at;
  }

  static fromApiResponse(data) {
    return new PageListItem(data);
  }

  static fromApiResponseList(dataList = []) {
    return dataList.map(PageListItem.fromApiResponse);
  }
}









